const spacing = {
  '2x-small': '0.125rem',
  'x-small': '0.25rem',
  small: '0.5rem',
  medium: '0.75rem',
  large: '0.85rem',
  'x-large': '1rem',
  '1.3x-large': '1.3rem',
  '2x-large': '1.5rem',
  '3x-large': '2rem',
  '3.3x-large': '2.3rem',
  '4x-large': '3rem',
  '5x-large': '4rem',
  '6x-large': '4.4rem',
  '7x-large': '6rem',
  '8x-large': '9rem',
  '9x-large': '18rem'
}

export type SpacingProps = typeof spacing
export default spacing
